import React, { useEffect, useState, useContext } from "react";
import "./index.css";
import { Link } from "react-router-dom";
import {
  getProductList,
  getSubgroupProductList,
  createSubgroupProduct,
  updateSubgroupProduct,
  deleteSubgroupProduct,
} from "../../apis/Product";
import Service from "../Service";
import menuproduct_bg from "../../assets/shapes_svg/product/bg_product_icon.svg";
import menuproduct_bg_chosen from "../../assets/shapes_svg/product/bg_product_chosen_icon.svg";
import product_ico from "../../assets/shapes_svg/product/product-icon.svg";
import service_ico from "../../assets/shapes_svg/product/service-icon.svg";
import project_ico from "../../assets/shapes_svg/product/project-icon.svg";
import { ContainerBody } from "../../App";
import { useTranslation } from "react-i18next";
import { getBusinessDetail } from "../../apis/Business/Business";
import EditIcon from "@mui/icons-material/Edit";
import Save from "@mui/icons-material/Save";
import ProductCarousel from "../../components/ProductCarousel";
import { useUserAccess } from "../../components/WriteAccessContext";
import ClearIcon from "@mui/icons-material/Clear";
import { AlertV2 } from "../../components/Alert";
import { useInvalidateQuery } from "../../components/InvalidateQueryContext";
import { ProductApiKey } from "../../apis/ApiKey/ProductApiKey";
import ProductComponentBox from "../NewProduct/components/ProductComponentBox";
import { YearTabContext } from "../../components/Skeleton";
import FilterableProductBar from "../NewProduct/components/ProductBar/FilterableProductBar";
import addPlusIcon from "../../assets/shapes_svg/product/plus-icon-prod.svg";
import FilterSearchProduct from "./FilterSearchProduct";
import RecentSubgroups from "./RecentSubgroups";

const Product = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");

  const [products, setProducts] = useState([]);
  const [productMenu, setProductMenu] = useState("product");
  const [chosenTab, setChosenTab] = useState("normal");
  const [subgroups, setSubgroups] = useState([]);
  const [chooseAlphabet, setChooseAlphabet] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [shared, setShared] = useState({});
  const [sharedSubgroups, setSharedSubgroups] = useState({});
  const [searchbar, setSearchbar] = useState("");
  const { t } = useTranslation();
  const [activeMainBusinessName, setActiveMainBusinessName] = useState(null);
  const [customSubCat, setCustomSubCat] = useState("");
  const [customSubCatNew, setCustomSubCatNew] = useState("");
  const [customSubCatSec, setCustomSubCatSec] = useState("");
  const [editCustomSubCatSec, setEditCustomSubCatSec] = useState(false);
  const [editCustomSubCatNew, setEditCustomSubCatNew] = useState(false);
  const [showAddSubgroup, setShowAddSubgroup] = useState(false);
  const [writeAccess, setWriteAccess] = useState(false);
  const { setUserAccessType, setIsShare, userAccess } = useUserAccess();
  const [editStates, setEditStates] = useState({});
  const [newSubgroupId, setNewSubgroupId] = useState("");
  const [deleteSubcategoryAlert, setDeleteSubcategoryAlert] = useState(false);
  const { invalidateKey, resetKey } = useInvalidateQuery();
  const { duplicateProduct, createProduct } = ProductApiKey;
  const yearTab = useContext(YearTabContext);
  const [filteredProducts, setFilteredProducts] = useState({});

  const handleEditSubgroup = (subgroupId, subgroupName) => {
    setCustomSubCat(subgroupName);
    setEditStates((prevState) => ({
      ...prevState,
      [subgroupId]: !prevState[subgroupId],
    }));
  };

  useEffect(() => {
    if (chosenTab === "normal") {
      setUserAccessType("write");
    }
  }, [chosenTab, setUserAccessType]);

  const handleSaveCustomSubCat = (name, id, shared_business = null) => {
    setEditStates((prevState) => ({
      ...prevState,
      [id]: false,
    }));
    if (chosenTab === "normal") {
      updateSubgroupProduct({
        name: name,
        id: id,
        callback: () => {
          getSubgroupProductList({
            setSubgroups: setSubgroups,
            setSharedSubgroups: setSharedSubgroups,
          });
        },
      });
    } else {
      updateSubgroupProduct({
        name: name,
        id: id,
        shared_business: shared_business,
        is_shared: true,
        callback: () => {
          getSubgroupProductList({
            setSubgroups: setSubgroups,
            setSharedSubgroups: setSharedSubgroups,
          });
        },
      });
    }
  };

  const handleSaveCustomSubCatNew = (name) => {
    setEditCustomSubCatNew(false);
    if (chosenTab === "normal") {
      createSubgroupProduct({
        name: name,
        setNewSubgroupId: setNewSubgroupId,
        callback: () => {
          getSubgroupProductList({
            setSubgroups: setSubgroups,
            setSharedSubgroups: setSharedSubgroups,
          });
        },
      });
    } else {
      const business = sharedSubgroups[chosenTab].data[0]?.business;
      const sharedAdmin = sharedSubgroups[chosenTab].id;
      createSubgroupProduct({
        name: name,
        is_shared: true,
        shared_business: business,
        shared_admin_id: sharedAdmin,
        setNewSubgroupId: setNewSubgroupId,
        callback: () => {
          getSubgroupProductList({
            setSubgroups: setSubgroups,
            setSharedSubgroups: setSharedSubgroups,
          });
        },
      });
    }
  };

  const handleSaveCustomSubCatSec = (name) => {
    setEditCustomSubCatSec(false);
    if (chosenTab === "normal") {
      createSubgroupProduct({
        name: name,
        setNewSubgroupId: setNewSubgroupId,
        callback: () => {
          getSubgroupProductList({
            setSubgroups: setSubgroups,
            setSharedSubgroups: setSharedSubgroups,
          });
        },
      });
    } else {
      const business = sharedSubgroups[chosenTab].data[0]?.business;
      const sharedAdmin = sharedSubgroups[chosenTab].id;
      createSubgroupProduct({
        name: name,
        is_shared: true,
        shared_business: business,
        shared_admin_id: sharedAdmin,
        setNewSubgroupId: setNewSubgroupId,
        callback: () => {
          getSubgroupProductList({
            setSubgroups: setSubgroups,
            setSharedSubgroups: setSharedSubgroups,
          });
        },
      });
    }
  };

  const handleToggleActive = (mainBusinessName) => {
    setActiveMainBusinessName(mainBusinessName);
  };

  const handleAddSubcategoryForm = () => {
    setShowAddSubgroup(!showAddSubgroup);
  };

  const handleClose = (setter) => {
    document.getElementsByTagName("body")[0].className = "";
    setter(false);
  };

  const handleDelete = () => {
    setDeleteSubcategoryAlert(true);
  };

  useEffect(() => {
    if (year || yearTab) {
      getProductList({
        setProducts: setProducts,
        setShared: setShared,
        setWriteAccess: setWriteAccess,
      });
      getSubgroupProductList({
        setSubgroups: setSubgroups,
        setSharedSubgroups: setSharedSubgroups,
      });
      getBusinessDetail({
        id: localStorage.getItem("id_business"),
        setName: setBusinessName,
      });
    }
  }, [year, yearTab]);

  useEffect(() => {
    if (invalidateKey === createProduct || invalidateKey === duplicateProduct) {
      getProductList({
        setProducts: setProducts,
        setShared: setShared,
        setWriteAccess: setWriteAccess,
      });
    }
    resetKey();
  }, [createProduct, duplicateProduct, invalidateKey, resetKey]);

  let allArraysEmpty = true;
  for (const key in sharedSubgroups) {
    if (
      sharedSubgroups.hasOwnProperty(key) &&
      sharedSubgroups[key]?.data?.length !== 0
    ) {
      allArraysEmpty = false;
      break;
    }
  }

  const trackRecentSubgroup = (subgroup) => {
    const stored = localStorage.getItem("recentSubgroups");
    let recent = stored ? JSON.parse(stored) : [];

    // Add current subgroup to front, remove duplicates, keep max 8
    recent = [
      { id: subgroup.id, name: subgroup.name, year: year ? year : yearTab },
      ...recent.filter((sg) => sg.id !== subgroup.id),
    ].slice(0, 8);

    localStorage.setItem("recentSubgroups", JSON.stringify(recent));
  };

  const handleDeleteSubgroup = (subgroupId) => {
    if (chosenTab === "normal") {
      deleteSubgroupProduct({
        id: subgroupId,
        callback: () => {
          getSubgroupProductList({
            setSubgroups: setSubgroups,
            setSharedSubgroups: setSharedSubgroups,
          });
        },
      });
    } else {
      const business = sharedSubgroups[chosenTab].data[0]?.business;
      const sharedAdmin = sharedSubgroups[chosenTab].id;

      deleteSubgroupProduct({
        id: subgroupId,
        is_shared: true,
        shared_business: business,
        shared_admin_id: sharedAdmin,
        callback: () => {
          getSubgroupProductList({
            setSubgroups: setSubgroups,
            setSharedSubgroups: setSharedSubgroups,
          });
        },
      });
    }
  };

  return (
    <>
      <ContainerBody className="product__body">
        <div className="product__body__inner">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              position: "absolute",
              top: "-34px",
            }}
          >
            <div
              className={`companydetail__info__prod ${
                activeMainBusinessName === null ? "active" : ""
              }`}
              onClick={() => {
                setChosenTab("normal");
                handleToggleActive(null);
                setIsShare(false);
                setUserAccessType("write");
              }}
            >
              <h6>{businessName ? businessName : t("Branches")}</h6>
            </div>
            {shared &&
              Object.keys(shared).map((mainBusinessName) => (
                <div
                  key={mainBusinessName}
                  className={`companydetail__info__prod ${
                    activeMainBusinessName === mainBusinessName ? "active" : ""
                  }`}
                  onClick={() => {
                    setChosenTab(mainBusinessName);
                    setUserAccessType(
                      writeAccess[mainBusinessName][0].is_write
                    );
                    setIsShare(true);
                    handleToggleActive(mainBusinessName);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <h6>{mainBusinessName}</h6>
                </div>
              ))}
          </div>
          <div className="top-product-section">
            <div className="top-product-left">
              <div
                className="product__or__service mt-0"
                style={{ margin: "20px", width: "100%" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundImage:
                      productMenu !== "product"
                        ? `url(${menuproduct_bg})`
                        : `url(${menuproduct_bg_chosen})`,
                    backgroundSize: "100% 100%",
                    width: "33%",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                    marginRight: "10px",
                    cursor: "pointer",
                    height: "135px",
                  }}
                  onClick={() => setProductMenu("product")}
                >
                  <img src={product_ico} alt="product" />
                  <h5
                    style={{
                      color: "white",
                      fontWeight: "600",
                      textAlign: "center",
                      marginTop: "10px",
                    }}
                  >
                    {t("PRODUCT")}
                  </h5>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundImage:
                      productMenu !== "service"
                        ? `url(${menuproduct_bg})`
                        : `url(${menuproduct_bg_chosen})`,
                    backgroundSize: "100% 100%",
                    width: "33%",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                    marginRight: "10px",
                    height: "135px",
                    cursor: "pointer",
                  }}
                  onClick={() => setProductMenu("service")}
                >
                  <img src={service_ico} alt="service" />
                  <h5
                    style={{
                      color: "white",
                      fontWeight: "600",
                      textAlign: "center",
                      marginTop: "10px",
                    }}
                  >
                    {t("SERVICE")}
                  </h5>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundImage:
                      productMenu !== "project"
                        ? `url(${menuproduct_bg})`
                        : `url(${menuproduct_bg_chosen})`,
                    backgroundSize: "100% 100%",
                    width: "33%",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                    height: "135px",
                    cursor: "pointer",
                  }}
                  onClick={() => setProductMenu("project")}
                >
                  <img src={project_ico} alt="project" />
                  <h5
                    style={{
                      color: "white",
                      fontWeight: "600",
                      textAlign: "center",
                      marginTop: "10px",
                    }}
                  >
                    {t("PROJECT")}
                  </h5>
                </div>
              </div>
              <RecentSubgroups year={year ? year : yearTab} />
            </div>
            <div className="product-desc-box">
              <p className="product-desc-box-title">Product</p>
              <p className="product-desc-box-text">
                Here in company, we start to map out products that the company
                has paid for and are delivered to the location, making this more
                manageable. It is possible to divide deliveries into
                sub-categories, where deliveries can be grouped by e.g.
                purchase/order number. We recommend grouping by supplier and if
                possible, by goods and services purchased for the production of
                a specific product. List deliveries of goods and services that
                the company has paid for and are delivered to the location. To
                make this more manageable, it is possible to divide deliveries
                into sub-categories, where deliveries can be grouped by e.g.
                purchase/order number.
              </p>
            </div>
          </div>

          <div className="product-search-section">
            {chosenTab === "normal" ? (
              <FilterSearchProduct
                subgroups={subgroups}
                products={products}
                year={year ? year : yearTab}
              />
            ) : (
              <FilterSearchProduct
                subgroups={sharedSubgroups[chosenTab]?.data}
                products={shared[chosenTab]}
                year={year ? year : yearTab}
              />
            )}
          </div>

          <div className="product__body__items">
            {productMenu === "product" ? (
              <>
                {userAccess === "write" && (
                  <div
                    className="add-subgroup-bg"
                    style={{ marginBottom: showAddSubgroup ? 0 : "50px" }}
                  >
                    <div className="add-subgroup-btn">Category</div>
                    <div
                      onClick={handleAddSubcategoryForm}
                      style={{
                        color: "#ffffff",
                        padding: "7px 16px",
                        display: "flex",
                        alignItems: "center",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      {showAddSubgroup ? t("CANCEL") : t("ADD_SUBCATEGORY")}{" "}
                      <img
                        src={addPlusIcon}
                        alt="Add new subgroup"
                        width={30}
                        height={30}
                        style={{ marginLeft: "5px" }}
                      />
                    </div>
                  </div>
                )}
                {showAddSubgroup && (
                  <>
                    <div
                      className="product__bubble__title"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "5px",
                      }}
                    >
                      <input
                        placeholder="Subgrouping name"
                        value={customSubCatSec}
                        onChange={(e) => {
                          setCustomSubCatSec(e.target.value);
                        }}
                        readOnly={!editCustomSubCatSec}
                      />
                      {editCustomSubCatSec ? (
                        <Save
                          onClick={() =>
                            handleSaveCustomSubCatSec(customSubCatSec)
                          }
                          style={{ color: "#FFFFFF" }}
                        />
                      ) : (
                        <EditIcon
                          onClick={() => setEditCustomSubCatSec(true)}
                          style={{ color: "#FFFFFF" }}
                        />
                      )}
                    </div>
                    <div className="product__bubble">
                      <ProductComponentBox
                        name={"Product"}
                        prodNum={"123456"}
                        isAddNew={true}
                        year={year}
                        subgroupId={newSubgroupId.id}
                        business={newSubgroupId.business}
                        subgroups={subgroups}
                      />
                    </div>
                  </>
                )}
                <>
                  {(subgroups && subgroups.length > 0) ||
                  (sharedSubgroups &&
                    Object.keys(sharedSubgroups)?.data?.length !== 0 &&
                    !allArraysEmpty) ? (
                    <>
                      {chosenTab === "normal" &&
                        (subgroups || []).map((subgroup, index) => {
                          const matchingProduct =
                            filteredProducts &&
                            Object.keys(filteredProducts).length > 0
                              ? filteredProducts[subgroup.id]
                              : products.find(
                                  (prod) =>
                                    prod.subgroup &&
                                    prod.subgroup === subgroup.id
                                );
                          return (
                            <React.Fragment key={index}>
                              <div
                                className="product__bubble"
                                style={{
                                  position: "relative",
                                  paddingTop: "30px",
                                }}
                              >
                                <FilterableProductBar
                                  subgroups={subgroups}
                                  products={products}
                                  isProductFront={true}
                                  idSubgroup={subgroup?.id}
                                  subgroupName={subgroup?.name}
                                  setFilteredResults={setFilteredProducts}
                                  editStates={editStates}
                                  setCustomSubCat={setCustomSubCat}
                                  handleSaveCustomSubCat={
                                    handleSaveCustomSubCat
                                  }
                                  handleEditSubgroup={handleEditSubgroup}
                                  trackRecentSubgroup={trackRecentSubgroup}
                                  subgroup={subgroup}
                                />
                                <ClearIcon
                                  onClick={handleDelete}
                                  style={{
                                    position: "absolute",
                                    top: 5,
                                    right: 20,
                                    color: "#C1B6BD",
                                    cursor: "pointer",
                                  }}
                                />
                                <ProductCarousel
                                  products={
                                    filteredProducts &&
                                    Object.keys(filteredProducts).length > 0
                                      ? filteredProducts[subgroup.id]
                                      : products
                                  }
                                  subgroup={subgroup}
                                >
                                  {(Array.isArray(matchingProduct)
                                    ? matchingProduct
                                    : matchingProduct
                                    ? [matchingProduct]
                                    : []
                                  ).map((product, i) => {
                                    return (
                                      <Link
                                        key={i}
                                        className="nav-link"
                                        to={`/product/${product.id}?business=${product.business}&year=${year}`}
                                        onClick={(e) => {
                                          trackRecentSubgroup(subgroup);
                                          e.target.tagName === "A" &&
                                            e.preventDefault();
                                        }}
                                      >
                                        <ProductComponentBox
                                          prodNum={product.product_num}
                                          name={product.name}
                                          productId={product.id}
                                          subgroup={subgroup.name}
                                          variationValues={
                                            product.variation_categories
                                          }
                                        />
                                      </Link>
                                    );
                                  })}
                                </ProductCarousel>

                                <ProductComponentBox
                                  name={"Product"}
                                  prodNum={"123456"}
                                  isAddNew={true}
                                  year={year}
                                  subgroupId={newSubgroupId.id}
                                  business={newSubgroupId.business}
                                  subgroups={subgroups}
                                />

                                <AlertV2
                                  open={deleteSubcategoryAlert}
                                  title={t("DELETE_SUBCATEGORY")}
                                  accept={() => {
                                    handleDeleteSubgroup(subgroup.id);
                                    setDeleteSubcategoryAlert(false);
                                  }}
                                  decline={() =>
                                    setDeleteSubcategoryAlert(false)
                                  }
                                />
                              </div>
                            </React.Fragment>
                          );
                        })}

                      {chosenTab !== "normal" &&
                        (Array.isArray(sharedSubgroups[chosenTab].data)
                          ? sharedSubgroups[chosenTab].data
                          : []
                        ).flatMap((subgroup) => {
                          const matchingShared =
                            filteredProducts &&
                            Object.keys(filteredProducts).length > 0
                              ? filteredProducts[subgroup.id]
                              : shared[chosenTab].find(
                                  (prod) =>
                                    prod.subgroup &&
                                    prod.subgroup === subgroup.id
                                );

                          return (
                            <>
                              <div
                                className="product__bubble"
                                style={{
                                  position: "relative",
                                  paddingTop: "30px",
                                }}
                              >
                                <FilterableProductBar
                                  subgroups={subgroups}
                                  products={shared[chosenTab]}
                                  isProductFront={true}
                                  idSubgroup={subgroup?.id}
                                  subgroupName={subgroup?.name}
                                  setFilteredResults={setFilteredProducts}
                                  editStates={editStates}
                                  setCustomSubCat={setCustomSubCat}
                                  handleSaveCustomSubCat={
                                    handleSaveCustomSubCat
                                  }
                                  handleEditSubgroup={handleEditSubgroup}
                                  trackRecentSubgroup={trackRecentSubgroup}
                                  subgroup={subgroup}
                                />
                                {userAccess === "write" && (
                                  <ClearIcon
                                    onClick={handleDelete}
                                    style={{
                                      position: "absolute",
                                      top: 5,
                                      right: 20,
                                      color: "#C1B6BD",
                                      cursor: "pointer",
                                    }}
                                  />
                                )}
                                <ProductCarousel
                                  products={
                                    filteredProducts &&
                                    Object.keys(filteredProducts).length > 0
                                      ? filteredProducts[subgroup.id]
                                      : shared[chosenTab]
                                  }
                                  subgroup={subgroup}
                                >
                                  {(Array.isArray(matchingShared)
                                    ? matchingShared
                                    : matchingShared
                                    ? [matchingShared]
                                    : []
                                  ).map((product, i) => {
                                    return (
                                      <Link
                                        key={i}
                                        className="nav-link"
                                        to={`/product/${product.id}?business=${product.business}&year=${year}`}
                                        onClick={(e) => {
                                          trackRecentSubgroup(subgroup);
                                          e.target.tagName === "A" &&
                                            e.preventDefault();
                                        }}
                                      >
                                        <ProductComponentBox
                                          prodNum={product.product_num}
                                          name={product.name}
                                          productId={product.id}
                                          subgroup={subgroup.name}
                                          variationValues={
                                            product.variation_categories
                                          }
                                        />
                                      </Link>
                                    );
                                  })}
                                </ProductCarousel>
                                {userAccess === "write" && (
                                  <ProductComponentBox
                                    name={"Product"}
                                    prodNum={"123456"}
                                    isAddNew={true}
                                    year={year}
                                    subgroupId={newSubgroupId.id}
                                    business={newSubgroupId.business}
                                    subgroups={subgroups}
                                  />
                                )}
                                <AlertV2
                                  open={deleteSubcategoryAlert}
                                  title={t("DELETE_SUBCATEGORY")}
                                  accept={() => {
                                    handleDeleteSubgroup(subgroup.id);
                                    setDeleteSubcategoryAlert(false);
                                  }}
                                  decline={() =>
                                    setDeleteSubcategoryAlert(false)
                                  }
                                />
                              </div>
                            </>
                          );
                        })}
                    </>
                  ) : (
                    <>
                      {userAccess === "write" && (
                        <>
                          <div
                            className="product__bubble__title"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              placeholder="Subgrouping name"
                              value={customSubCatNew}
                              onChange={(e) => {
                                setCustomSubCatNew(e.target.value);
                              }}
                              readOnly={!editCustomSubCatNew}
                            />
                            {editCustomSubCatNew ? (
                              <Save
                                onClick={() =>
                                  handleSaveCustomSubCatNew(customSubCatNew)
                                }
                                style={{ color: "#FFFFFF" }}
                              />
                            ) : (
                              <EditIcon
                                onClick={() => setEditCustomSubCatNew(true)}
                                style={{ color: "#FFFFFF" }}
                              />
                            )}
                          </div>
                          <div className="product__bubble">
                            <ProductComponentBox
                              name={"Product"}
                              prodNum={"123456"}
                              isAddNew={true}
                              year={year}
                              subgroupId={newSubgroupId.id}
                              business={newSubgroupId.business}
                              subgroups={subgroups}
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}
                </>
              </>
            ) : null}

            {productMenu === "service" ? (
              <Service
                chooseAlphabet={chooseAlphabet}
                searchbar={searchbar}
                chosenTab={chosenTab}
              />
            ) : null}
          </div>
        </div>
      </ContainerBody>
    </>
  );
};

export default Product;
